import { useContext, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { DatePicker } from "react-responsive-calendar-picker";

// icons
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";

// helpers
import { formatDate } from "helpers/dateFormatter";
import { sameDayCheckin } from "helpers/sameDayCheckin";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// style
import "./style.scss";
import {
	collectionUrl,
	collectionUrlCalendar,
	searchUrlCalendar,
} from "helpers/url";
import { useSearchQuery } from "customHooks/useQuery";
import moment from "moment";

export const CalendarPopup = ({ setCalendarPopup }: any) => {
	// @ts-ignore
	const { setShowCalendarPopup } = useContext(SearchPageDataInterface);

	const [searchParams, setSearchParams] = useSearchParams();

	const query = useSearchQuery();

	const navigate = useNavigate();
	const { pathname } = useLocation();

	const [dates, setDates] = useState({
		checkin:
			(query?.get("checkin") !== "" &&
				query?.get("checkin") !== null &&
				// @ts-ignore
				new Date(query.get("checkin"))) ||
			"",
		checkout:
			(query?.get("checkout") !== "" &&
				query?.get("checkin") !== null &&
				// @ts-ignore
				new Date(query.get("checkout"))) ||
			"",
	});

	const [open, setOpen] = useState(false);

	return (
		<div className="search__calendar-container">
			<div className="search__calendar-close">
				<SvgNavigationArrow
					onClick={() => {
						if (pathname.split("/")[1] !== "collection") {
							setShowCalendarPopup(false);
						} else {
							setCalendarPopup(false);
						}
					}}
				/>
			</div>
			<h2>Add your dates</h2>
			<DatePicker
				dates={dates}
				open={true}
				setOpen={setOpen}
				setDates={setDates}
				sticky={false}
				mobile={true}
				noMonth={3}
				sameDay={sameDayCheckin(1) ? 1 : 0}
			>
				<div className="search-elements dates">
					<div className="dates-input-wrapper">
						<input
							autoComplete="off"
							autoFocus
							required
							type="text"
							name="checkin"
							id="dates-checkin-input"
							inputMode="none"
							value={
								dates.checkin < dates.checkout ? formatDate(dates.checkin) : ""
							}
						/>
						<label>Check in</label>
					</div>
					<span className="dash-span">{"-"}</span>
					<div className="dates-input-wrapper">
						<input
							autoComplete="off"
							autoFocus
							required
							type="text"
							name="checkout"
							inputMode="none"
							id="dates-checkout-input"
							value={
								dates.checkout > dates.checkin ? formatDate(dates.checkout) : ""
							}
						/>
						<label>Check out</label>
					</div>
				</div>
			</DatePicker>
			<div className="btn-wrapper">
				<button
					aria-label="clear-dates"
					onClick={() => {
						setDates({
							checkin: "",
							checkout: "",
						});
					}}
				>
					Clear
				</button>
				<button
					aria-label="apply-dates"
					className="next-btn"
					onClick={() => {
						if (pathname === "/search") {
							//@ts-ignore
							window.location.href = searchUrlCalendar(query, dates, "/search");
						} else if (pathname.split("/")[1] === "villas") {
							//@ts-ignore
							window.location.href = searchUrlCalendar(query, dates, "villas");
						} else if (pathname.split("/")[1] === "collection") {
							searchParams.set(
								"checkin",
								moment(dates.checkin).format("YYYY/MM/DD"),
							);
							searchParams.set(
								"checkout",
								moment(dates.checkout).format("YYYY/MM/DD"),
							);
							setSearchParams(searchParams, { replace: true });
							setCalendarPopup(false);
						} else {
							window.location.href = collectionUrlCalendar(
								query,
								dates,
								pathname,
							);
						}
					}}
				>
					Save
				</button>
			</div>
		</div>
	);
};
